import Styles from './MonaHead.module.css'

export interface MonaHeadProps {
  variant: 'black' | 'purple'
}

export const defaultProps: Partial<MonaHeadProps> = {}

export const MonaHead = (props: MonaHeadProps) => {
  const initializedProps: MonaHeadProps = {...defaultProps, ...props}
  // eslint-disable-next-line no-empty-pattern
  const {} = initializedProps

  return <div className={Styles['MonaHead']}>MonaHead</div>
}
